import React, { useState } from "react";
import Collapse from "@mui/material/Collapse";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { STATIC_PATH } from "../../../config.tsx";
import { cn } from "../../../utils/cn";
import styles from "./DeliveryAndPaymentPage.module.scss";

//@transfer-from-shop_public_app
const DeliveryAndPaymentPage = () => {
  const [open, toggle] = useState(false);

  return (
    <div className={styles.root}>
      <Paper className={styles.block} elevation={4}>
        <Typography variant="h4" className={styles.type}>
          Доставка
        </Typography>
        <Typography variant="h5" className={styles.title}>
          По России
        </Typography>

        <Typography variant="body1" className={cn(styles.title, styles.marginBottom)}>
          <div>
            <img
              src={`${STATIC_PATH}/a98d1b44c4ebdc661dea45f7e6b79604.png`}
              alt="Почта РФ"
            />
          </div>
          <b>Почта РФ</b>
          <span>
            <InfoOutlined />
            Стоимость рассчитывается сразу при оформлении заказа
          </span>
          <div className={cn(styles.recommend, styles.absolute)}>
            <CheckCircleOutline /> Рекомендуем
          </div>
        </Typography>
        <Typography variant="body1" className={styles.title}>
          <div>
            <img
              src={`${STATIC_PATH}/dc661dea45a98d1b44c4ebf7e6b79604.png`}
              alt="ДВТЭК"
            />
          </div>
          <b>ДВТЭК</b>
          <span>
            <InfoOutlined />
            Стоимость рассчитывается сразу при оформлении заказа
          </span>
        </Typography>
        <Typography variant="body1" className={styles.title}>
          <div>
            <img
              src={`${STATIC_PATH}/6b79604dc661deab44c4ebf7e45a98d1.png`}
              alt="BUS курьер"
            />
          </div>
          <div>
            <div>
              <b>BUS курьер</b>
            </div>
            <div className={styles.bus}>
              <Typography variant="caption">
                Только для
                <br />
                Приморского края
              </Typography>
            </div>
          </div>
          <span>
            <InfoOutlined />
            Стоимость рассчитывается сразу при оформлении заказа
          </span>
        </Typography>
        <Typography
          variant="body1"
          className={cn(styles.title, styles.lastItem)}
        >
          <div>
            <img
              src={`${STATIC_PATH}/40cfca451f9fb46edbf94bbe9158814e.jpg`}
              alt="Энергия"
            />
          </div>
          <b>Энергия</b>
        </Typography>
        <Collapse in={open}>
          <div className={styles.listCompany}>СДЭК</div>
          <div className={styles.listCompany}>
            Ромаха <sup>*</sup>
          </div>
          <div className={styles.listCompany}>
            Мы с камчатки <sup>*</sup>
          </div>
          <div className={styles.listCompany}>
            ТрансЭкспедиция <sup>*</sup>
          </div>
          <div className={styles.listCompany}>
            Флагман Амур <sup>*</sup>
          </div>
          <div className={styles.listCompany}>
            Баграм <sup>*</sup>
          </div>
          <div className={styles.listCompany}>Тройка-ДВ</div>
          <div className={styles.listCompany}>ПЭК</div>
          <div className={styles.listCompany}>ЖелдорЭкспедиция</div>
          <br />
          <div className={cn(styles.listCompany, styles.sup)}>
            <sup>*</sup> доставка указанными ТК только в определенные города
          </div>
        </Collapse>
        <a onClick={() => toggle(!open)} className={styles.a}>
          {open ? "свернуть" : "и другие"}
        </a>
        <Typography variant="h5" className={styles.title}>
          По Владивостоку
        </Typography>
        <Typography variant="h6" className={styles.subheading}>
          <b>Курьерская доставка</b>
        </Typography>
        <Typography variant="body1" className={styles.item}>
          <span>
            В пределах города — <b>350</b> руб. (стоимость вечерних доставок до клиента в черте г. Владивосток с 18:30 до 20:00 составляет <b>400</b> руб.).
          </span>
        </Typography>
        <Typography variant="body1" className={styles.item}>
          <span> Пригород — рассчитывается индивидуально.</span>
        </Typography>
        <Typography variant="body1" className={styles.item}>
          Стоимость доставки крупногабаритного товара уточняйте у менеджеров:
          <br />
          — бамперы
          <br />
          — капоты
          <br />
          — двери
          <br />
          — стекла
        </Typography>
        <Typography variant="body1" className={styles.item}>
          <span> В пределах города доставка до ТК - 150 руб.</span>
        </Typography>
        <br />
        <Typography variant="h6" className={styles.subheading}>
          <b>Самовывоз из пункта выдачи</b>
        </Typography>
        <Typography variant="body1" className={styles.item}>
          — Снеговая, 4
        </Typography>
      </Paper>
      <Paper className={styles.block} elevation={4}>
        <Typography variant="h4" className={styles.type}>
          Оплата
        </Typography>
        <Typography variant="h6" className={styles.subheading}>
          <b>Наличный расчёт</b>
        </Typography>
        <Typography variant="body1" className={styles.item}>
          Вы можете оплатить покупку наличными при получении в пункте выдачи по адресу: ул. Снеговая, 4
        </Typography>
        <br />
        <Typography variant="h6" className={styles.subheading}>
          <b>Пластиковые карты</b>
        </Typography>
        <Typography variant="body1" className={styles.item}>
          Безналичная оплата банковской картой при получении. Принимаются карты следующих платёжных систем: «VISA», «MasterCard», «МИР».
        </Typography>
        <Typography
          variant="body1"
          className={cn(styles.titleCard, styles.cards)}
        >
          <img src={`${STATIC_PATH}/visa.png`} alt="Почта РФ" />
          <img src={`${STATIC_PATH}/mastercard.png`} alt="MASTERCARD" />
          <img src={`${STATIC_PATH}/mir.png`} alt="КАРТА МИР" />
        </Typography>
        <br />
        <Typography variant="h6" className={styles.subheading}>
          <b>СБП (Система Быстрых Платежей)</b>
        </Typography>
        <Typography variant="body1" className={styles.item}>
          СБП позволяет мгновенно переводить деньги между счетами разных банков по номеру мобильного телефона, который привязан к определённому банковскому счёту.
        </Typography>
        <br />
        <Typography variant="h6" className={styles.subheading}>
          <b>Онлайн-оплата на сайте</b>
        </Typography>
        <Typography variant="body1" className={styles.item}>
          Оплата осуществляется через компании-партнеры – Сбербанк, Тинькофф. Комиссия не взимается. К оплате принимаются банковские карты «VISA», «MasterCard», «МИР». А также через сервис «Долями».
        </Typography>
        <br />
        <Typography variant="h6" className={styles.subheading}>
          <b>Долями</b>
        </Typography>
        <Typography variant="body1" className={styles.item}>
          Способ оплаты, позволяющий разделить сумму покупки на 4 равных части без комиссий и переплат. <br />
          Первые 25% оплачиваются при оформлении заказа, оставшиеся 3 равных части спишутся с вашей карты с интервалом 2 недели. <br />
          Оплатить Долями можно заказ на сумму до 30 000 рублей без учёта стоимости доставки. <br />
          Для оформление необходимо предоставить только ФИО, номер телефона и банковскую карту. <br />
          Долями — это сервис Тинькофф для оплаты заказов в интернет-магазинах. <br />
        </Typography>
        <br />
        <Typography variant="h6" className={styles.subheading}>
          <b>Безналичный расчет</b>
        </Typography>
        <Typography variant="body1" className={styles.item}>
          Доступен для юридических лиц (ООО, ЧП, ИП и т.п.).
        </Typography>
        <br />
        <Typography variant="h6" className={styles.subheading}>
          <b>Бонусами</b>
        </Typography>
        <Typography variant="body1" className={styles.item}>
          Полученными бонусы за покупки можно оплачивать следующие заказы со скидкой.
        </Typography>
      </Paper>
    </div>
  );
};

export default DeliveryAndPaymentPage;
